import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import SubMenu from './component/sub-menu';
import './index.scss';
import http from '../../utils/request'
import { getCookie, delCookie } from '../../utils/cookie'

class Header extends Component {

  constructor(props) {
    super(props)

    this.state = {
      active: false,
      keepActive: false,
      headMenu: [],
      mobile: ''
    }
  }

  componentDidMount() {
    const that = this;
    let cookieItem = getCookie('userinfo')
    if (cookieItem) {
      cookieItem = JSON.parse(cookieItem)
      const token = cookieItem.token;
      // 校验token
      http('post', '/achieve/user/check', { token }).then(res => {
        if (res.code === 200) {
          cookieItem.mobile && that.setState({ mobile: cookieItem.mobile })
        } else {
          delCookie('userinfo')
          that.setState({ mobile: '' })
        }
      })
    }
    http('post', '/achieve/circle/head').then(res => {
      if (res.code === 200) {
        this.setState({
          headMenu: res.data
        })
      }
    })
    window.addEventListener('scroll', this.handleScroll);

    const { location } = this.props;
    const _pathName = location.pathname.split('/')[1];
    if (_pathName === "detail" || _pathName === 'expertdetail' || _pathName === 'publish' || _pathName === 'demand' || _pathName === 'case') {
      this.setState({
        keepActive: true
      });
    }
    this.unListen = this.props.history.listen(route => { // 监听
      const pathUrl = route.pathname.split('/')[1]
      const { query } = route;
      if (pathUrl === "detail" || pathUrl === 'expertdetail' || pathUrl === 'publish' || pathUrl === 'demand' || pathUrl === 'case') {
        this.setState({
          keepActive: true
        });
      } else {
        this.setState({
          keepActive: false
        });
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.unListen && this.unListen();
  }

  handleScroll = (event) => {
    let ctx = this;

    let clientHeight = document.documentElement.clientHeight; //可视区域高度
    let scrollTop = document.documentElement.scrollTop;  //滚动条滚动高度
    let scrollHeight = document.documentElement.scrollHeight; //滚动内容高度
    if (scrollTop > 100) {
      ctx.setState({ active: true })
    } else {
      ctx.setState({ active: false })
    }
  }

  handleClickItem(e) {
    let allCategory = document.querySelectorAll('.pc-header__item');
    const selectedItem = e.currentTarget;
    if (selectedItem && selectedItem.dataset && selectedItem.dataset.jsItem) {
      if (selectedItem.dataset.jsItem.indexOf('http') < 0) {
        allCategory.forEach(item => {
          item.className = "pc-header__item"
        });
        selectedItem.className = "pc-header__item active"
      }
    } else {
      allCategory.forEach(item => {
        item.className = "pc-header__item"
      });
    }
  }

  toHome = () => {
    let allCategory = document.querySelectorAll('.pc-header__item');
    allCategory.forEach(item => {
      if (item.dataset.jsItem === '/') {
        item.className = "pc-header__item active"
      } else {
        item.className = "pc-header__item"
      }
    });
  }

  render() {
    const { active, keepActive, headMenu, mobile } = this.state;
    return (
      <Fragment>
        <div className={`pc-header ${active || keepActive ? 'active' : ''}`}>
          <div className="pc-header__content">
            <div className="pc-header__logo">
              <Link to='/' onClick={this.toHome}>
                <img className="blue" src="https://achieve.obs.cn-southwest-2.myhuaweicloud.com/achieve/img/blue.svg" alt=""></img>
                <img className="white" src="https://achieve.obs.cn-southwest-2.myhuaweicloud.com/achieve/img/white.svg"></img>
              </Link>
            </div>

            <div className="pc-header__tip">
              <nav className="pc-header__nav">
                <ul className="pc-header__menu" data-js-menu>
                  {
                    headMenu.length > 0 && (
                      headMenu.map(item => {
                        const outerUrl = item.path ? item.path.indexOf('http') : -2; // 0+代表外部跳转链接 -1代表路由跳转 -2代表无跳转
                        return (
                          <li key={item.title} className="pc-header__item" data-js-item={item.path} onClick={this.handleClickItem.bind(this)}>
                            {
                              outerUrl > -1 && (
                                <a href={item.path ? item.path : '#'} target="_blank" rel="noopener noreferrer" className="pc-header__link">{item.title}</a>
                              )
                            }
                            {
                              outerUrl === -1 && (
                                <Link to={item.path ? item.path : '#'} className="pc-header__link">{item.title}</Link>
                              )
                            }
                            {
                              outerUrl === -2 && (
                                <span className="pc-header__link">{item.title}</span>
                              )
                            }
                            {
                              item.category && item.category.length > 0 && (
                                <SubMenu secondMenu={item.category} firstPath={item.path}></SubMenu>
                              )
                            }
                          </li>
                        )
                      })
                    )
                  }
                </ul>
              </nav>
            </div>

            <div className="pc-header__sign-status">
              {
                mobile ? (
                  <div className="container-box">
                    <a href='#' className="button">{mobile}</a>
                  </div>
                ) : (
                  <div className="container-box">
                    <a href='http://user.gmih.scimea.cn/reg' className="button">注册</a>
                    <span className="line">|</span>
                    <a href='http://user.gmih.scimea.cn/login' className="button">登录</a>
                  </div>
                )
              }
            </div>
          </div>

        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
});

const mapDispathToProps = (dispatch) => ({

});

export default withRouter(connect(mapStateToProps, mapDispathToProps)(Header));